import { all, takeLatest } from "redux-saga/effects";

import { signIn } from "./auth";
import { AuthTypes } from "../ducks/auth";

export default function* rootSaga() {
  // yield fork(loginStatusWatcher);
  yield all([takeLatest(AuthTypes.SIGN_IN_REQUEST, signIn)]);
}
